/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkSelection } from './bulkSelection';
import type { PipelineFilterSchema } from './pipelineFilterSchema';

/**
 * Export candidates from a job's pipeline.
 *
 * Provide exactly one of an explicit ``job_candidate_ids`` list or a ``bulk``
 * selection descriptor; ``stage_id``/``search``/``filters`` scope a ``bulk``
 * resolution to the active pipeline filters, so an "export all" never reaches
 * past what the filtered table was showing.
 */
export interface PipelineExportSourceSchema {
  type?: 'pipeline';
  job_id: string;
  job_candidate_ids?: string[] | null;
  bulk?: BulkSelection | null;
  stage_id?: string | null;
  search?: string | null;
  filters?: PipelineFilterSchema | null;
}
